module.exports = __webpack_public_path__ + "static/media/pre-cadastro-img.e74ccf2b.webp";